import { unref, computed } from 'vue'

/**
 * ユーザーリスト表示項目(バッテリー)の利用
 * @param {MaybeRef.<number>} value バッテリー値
 */
export function useUserStatusAdditionalItemBattery({ value }) {
  /**
   * バッテリー残量表示テキスト
   * @type {ComputedRef.<string>}
   */
  const text = computed(() => {
    const v = unref(value)
    return v == null ? '-%' : `${v}%`
  })

  return { text }
}
